<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
            {{ userStore.user.address }}<br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }} <br />
            {{ userStore.user.ssn }} <br />
            <br />
            {{ dataFurnisher.address_name }} <br />
            {{ dataFurnisher.street_address }} <br />
            {{ dataFurnisher.city }}, {{ dataFurnisher.state_abbrev }} {{ dataFurnisher.zipcode }}
            <br />
            <br />
            Date: {{ date }}
            <br />
            <br />
        </p>
        <p class="letter-content">
            Pursuant to my rights under federal and state law, I request that a clear and
            accurate full file disclosure be made to me of all information you have in your files
            about me.
        </p>
        <p class="letter-content">
            More specifically, under <strong> Section 609 (15 U.S.C. § 1681g) of the FCRA,</strong>

        </p>
        <p class="letter-content">
            I am entitled to receive, as a result of this full file disclosure request,
            all information recorded and retained in your file, the sources of such
            information in the file, information such as the names of such persons or entities
            who have produced a consumer report about me, and a record of all inquiries received that identified me.
            I also request disclosure of the sources of such information, and
            the names of all recipients of any consumer reports on me furnished by
            within the limits prescribed by law.
        </p>
        <p class="letter-content">
            To obtain a copy of my consumer report, which was requested through
            {{dataFurnisher.name}}, the following information is supplied for
            identification purposes only. It is my understanding that {{dataFurnisher.name}}
            will mail me a copy of my report within 15 days of this File Disclosure Request Form,
        </p>

        <p>
            My <strong>Personal Information</strong> is clearly shown below: <br />
            <strong>FULL NAME:</strong> {{ userStore.user.firstname }} {{ userStore.user.lastname }} <br />
            <strong>DATE OF BIRTH:</strong> {{ userStore.user.dob }}<br />
            <strong>SOCIAL SECURITY NUMBER: </strong> {{ userStore.user.ssn }} <br />
            <strong>PHONE:</strong> {{ userStore.user.phone }}<br />
            <strong>FULL CURRENT ADDRESS: </strong> {{ userStore.user.address }} {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        </p>
        <p class="letter-content">
            <br />
            <br />
            Sincerely, <br />
        </p>

        <p style="page-break-before: always; padding-top: 1rem; text-align: center;">
            <strong class="letter-content">
                Note: Attached you will find my drivers license. Please do not retain on record.
                Upon confirmation of my
                identity, you will need to purge the copy of the Drivers License attached. I
                do not authorize your company
                to store or share <strong>any</strong> of my Personal Identification.
            </strong>
        </p>
        <h1 style="text-align: center;">Personal Information</h1>
        <p style="padding-top: 1rem; text-align: center;">
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            dataFurnisher: {
                type: [Array, Object]
            }
        },
        setup(props) {
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore()
            };
        }
    };
</script>
